module.exports = __webpack_public_path__ + "static/media/redecorating.45aa2117.svg";